import { Pagination, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import ErrorMessage from '../../../components/ErrorMessage/ErrorMessage';
import Icon from '../../../components/Icon/Icon';
import Spinner from '../../../components/Spinner/Spinner';
import Tag from '../../../components/Tag/Tag';
import { Status, TableData, TabStatus } from './MenteeTab.model';
import styles from './MenteeTab.module.scss';
import { pageSize, useMenteeTab } from './useMenteeTab';

const MenteeTab = ({ searchTerm }: any) => {
	const {
		getRequests,
		onChangePagination,
		state: { pagination, tabStatus, upgradeRequests },
	} = useMenteeTab({ searchTerm });

	const intl = useIntl();

	const history = useHistory();

	const getTagColorByStatus = (status: Status) => {
		switch (status) {
			case Status.Accepted: return "green";
			case Status.Rejected: return "red";
			case Status.Pending: return "grey";
		}
	}

	const requestsColumns: ColumnsType<TableData> = [
		{
			dataIndex: 'name',
			render: (name: string, record: TableData) => (
				<div className={styles.flexCell}>
					{' '}
					<div className={styles.avatar}>
						{record.imageId ? (
							<img src={record.imageId} alt="" />
						) : (
							<Icon color="light" height="12px" name="user" width="12px" />
						)}
					</div>
					<span>{name}</span>
				</div>
			),
			title: intl.formatMessage({ id: 'table.column.name' }),
		},
		{
			dataIndex: 'createdAt',
			title: intl.formatMessage({ id: 'table.column.date' }),
		},
		{
			dataIndex: 'status',
			render: (status: Status) => (
				<Tag noBackground color={getTagColorByStatus(status)}><div className={styles.flexTag}>{intl.formatMessage({ id: `status.${status.toLowerCase()}` })}</div></Tag>
			),
			title: intl.formatMessage({ id: 'table.column.status' }),
		},
	];

	const onClickRow = (rowData: TableData) => {
    return {
			onClick: () => {
				history.push(`/upgrade-request/${rowData.id}/`);
			},
    };
  }

	return (
		<div className={styles.tabContent}>
			<Spinner spinning={tabStatus === TabStatus.Loading} />
			<ErrorMessage error={tabStatus === TabStatus.Error} onRefresh={getRequests} showReport={false}/>
			<Table
				columns={requestsColumns}
				pagination={false}
				dataSource={upgradeRequests}
				onRow={onClickRow}
				rowKey={(record: TableData) => record.id}
			/>

			<div className={styles.paginationWrapper}>
				<Pagination
					current={pagination.page}
					pageSize={pageSize}
					total={pagination.total}
					onChange={onChangePagination}
					showSizeChanger={false}
				/>
			</div>
		</div>
	);
};
export default MenteeTab;
